/* src/students/Scene.js */

import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import { Grid, Paper } from '@material-ui/core';
import { LineGraph } from '../dashboard/components';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import StudentListCard from './cards/StudentListCard';
// import LessonCard from '../lessons/cards/LessonCard';
import { loadTexts } from '../../config/texts';

const TEXT_KEY = "students";

class Students extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      texts: loadTexts(TEXT_KEY, props.locale),
    };
  }

  renderAnalytics() {
    const { texts } = this.state;
    <div>
      <Paper>
        <LineGraph
          title={texts.title.lesson_analysis}
          data={[0, 1, 10, 24, 9]}
          labels={[1, 2, 3, 4, 5]}
          //label={capitalize(currentType)}
          //onTimeFrameChange={this._onTimeFrameChange}
          //onTypeChange={this._onTypeChange}
        //  timeFrames={this._timeFrames}
          //types={this._types}
          //currentTimeFrame={currentTimeFrame}
          //currentType={currentType}
          //startDate={startDate}
          //endDate={endDate}
          //onChangeStartDate={this._onChangeStartDate}
          //onChangeEndDate={this._onChangeEndDate}
          //onClickUpdate={this._onClickUpdate}
        />
      </Paper>
    </div>
  }

  render() {
    const { classes } = this.props;
    return (
      <Grid container className={classes.root} spacing={16}>
        <Grid item xs={12} md={12}>
          {this.renderAnalytics()}
        </Grid>
        <Grid item xs={12} md={12}>
          <StudentListCard innerRef={node => this.list = node} />
        </Grid>
      </Grid>
    );
  }
}

const styles = () => ({
  root: {
    flexGrow: 1,
  },
  card: {
    height: 800,
    overflowY: 'auto',
  },
});

Students.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  locale: state.appState.locale,
});

export default compose(
  withStyles(styles, { name: 'Students' }),
  connect(mapStateToProps, {})
)(Students);



// WEBPACK FOOTER //
// ./src/modules/students/Scene.js